// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"1edeeeb9","661":"e9f9abe0"}[chunkId] + ".chunk.js";
};